import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: table;
  width: 100%;
  height: 100%;
`;

const Title = styled.h1`
  color: ${({theme}) => theme.primaryColor};
  display: table-cell;
  vertical-align: bottom;
  font-weight: bold;
  font-size: ${({theme}) => theme.fontBig};
`;

export default props => (
  <Wrapper>
    <Title>{props.children}</Title>
  </Wrapper>
);
